module.exports = __webpack_public_path__ + "static/media/salute_vita_blue.8c0522d1.png";